import { Component } from "preact";
import style from "./style.css";

class Select extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
    };
    this.onChange = this.onChange.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
  }

  onChange(event) {
    const { onFilter, filters } = this.props;
    this.setState({ value: event.target.value });
    let queryParams = null;
    if (filters) {
      queryParams = `${event.target.value}&
                    year=${filters.year}&
                    portal=${filters.portal}&
                    field_of_operation=${filters.field_of_operation}&
                    donor=${filters.donor}&
                    oecd=${filters.oecd}&
                    sdg=${filters.sdg}`.replace(/  +/g, "");
    } else {
      queryParams = `${event.target.value}`;
    }
    onFilter(queryParams);
  }

  onSelect(option) {
    this.props.onSelect(option.value);
    this.setState({ value: option.label });
    this.props.onFilter("");
  }

  clearSearch() {
    this.props.onSelect("");
    this.setState({ value: "" });
    this.props.onFilter("");
  }

  render() {
    const { value } = this.state;
    const { label, options } = this.props;
    return (
      <div className={style.mainWrapper}>
        <span>{label}</span>
        <div>
          <input
            placeholder="Search for an item"
            type="text"
            onInput={this.onChange}
            value={value}
          />
          {value ? (
            <i className="fas fa-times" onClick={this.clearSearch} />
          ) : (
            <i />
          )}
        </div>
        <div>
          {options.map((option) => (
            <div key={option.key} onClick={() => this.onSelect(option)}>
              {option.label}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default Select;



// WEBPACK FOOTER //
// ./components/select/index.js